'use client';

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { ChipElement, TextElement } from './elements';
import { ChipIcon } from './ChipIcon';
import { StateLayer } from '../../core-components';
export const LinkChip = /*#__PURE__*/React.forwardRef(({
  label,
  onClick,
  size = 'small',
  iconLeftSrc,
  iconRightSrc,
  targetUrl,
  isSpa,
  target,
  edgeItemsMargin,
  ...rest
}, fRef) => {
  const handleClick = event => {
    onClick === null || onClick === void 0 ? void 0 : onClick(event);
    const isInternal = !target || target === '_self';
    if (isSpa && isInternal) {
      window.location.href = targetUrl;
    }
  };
  return /*#__PURE__*/React.createElement(ChipElement, _extends({
    as: "a",
    ref: fRef,
    onClick: handleClick,
    tabIndex: 0,
    $size: size,
    href: targetUrl,
    $edgeItemsMargin: edgeItemsMargin
  }, rest), /*#__PURE__*/React.createElement(StateLayer, null), iconLeftSrc && /*#__PURE__*/React.createElement(ChipIcon, {
    src: iconLeftSrc,
    size: size,
    side: "left"
  }), /*#__PURE__*/React.createElement(TextElement, null, label), iconRightSrc && /*#__PURE__*/React.createElement(ChipIcon, {
    src: iconRightSrc,
    size: size,
    side: "right"
  }));
});